import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { S_AnnotationStatus } from '../../../../annotations/annotationStatus/S_AnnotationStatus';
import { ColumnLayout } from '../../../../common/layouts/columnLayout/ColumnLayout';

interface IObjectClassificationInspectorProps {
  confidence: number | null;
  groundTruth: string | null | undefined;
  prediction: string | null;
}

export const ObjectClassificationInspector = ({ confidence, groundTruth, prediction }: IObjectClassificationInspectorProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <ColumnLayout size='sm'>
      <div className='attributes'>
        <span className='attribute'>
          {t('prediction.confidence')}: <S_AnnotationStatus text={confidence ? confidence.toFixed(3) : t('na')} />
        </span>
      </div>
      {groundTruth !== undefined && (
        <div className='attributes'>
          <span className='attribute'>
            {t('prediction.annotation.text')}: <S_AnnotationStatus text={groundTruth ? groundTruth : t('na')} />
          </span>
        </div>
      )}
      <div className='attributes'>
        <span className='attribute'>
          {t('prediction.inference.text')}: <S_AnnotationStatus text={prediction ? prediction : t('na')} />
        </span>
      </div>
    </ColumnLayout>
  );
};
